
<mat-form-field class="flex-1"
               
                (keypress)="filterEnter($event)">
    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [formControl]="newNoteControl"
              class=" width-100p" [placeholder]="label">
    </textarea>
</mat-form-field>
<button class="home365-button buttonBox" id="save_btn" (click)="saveMessage($event)"
        [disabled]="isDisabled || !newNoteControl.value">
  <!-- <mat-icon>send</mat-icon> -->
  <i class="fa-solid fa-paper-plane-top"></i>
</button>

<div *ngIf="(isCheckOutStatus$|async) && !isOuterUser">
  <button *ngIf="(isCheckIn$|async)" class="home365-button flex center-vr inverted check-in" (click)="checkInPopupComponent()" [disabled]="isDisabled">
    Check-in
  </button>
  <button *ngIf="!(isCheckIn$|async)" class="home365-button flex center-vr inverted check-in" (click)="checkOutPopupComponent()">
    Check-out
  </button>
</div>



